"use strict";
exports.__esModule = true;
exports.Api = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
require("isomorphic-fetch");
var Api = /** @class */ (function () {
    function Api() {
        this.baseUrl = null;
        this.token = null;
    }
    Api.prototype.serializeQueryParams = function (parameters) {
        return Object.keys(parameters)
            .reduce(function (acc, p) {
            var param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], acc, true), [
                "".concat(encodeURIComponent(p), "=").concat(encodeURIComponent(String(parameters[p]))),
            ], false);
        }, [])
            .join('&');
    };
    Api.prototype.paramsToObject = function (params) {
        var query = params.substr(1);
        var result = {};
        query.split('&').forEach(function (part) {
            var item = part.split('=');
            result[item[0]] = decodeURIComponent(item[1]);
        });
        return result;
    };
    Api.prototype.mergeQueryParams = function (parameters, queryParameters) {
        if (parameters.$queryParameters) {
            Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                var parameter = parameters.$queryParameters[parameterName];
                queryParameters[parameterName] = parameter;
            });
        }
        return queryParameters;
    };
    Api.prototype.transformParameter = function (value, transformOperation) {
        if (transformOperation === void 0) { transformOperation = null; }
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    };
    /**
     * HTTP Request
     * @method
     * @param {string} method - http method
     * @param {string} url - url to do request
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     */
    Api.prototype.request = function (method, url, body, headers, queryParameters, form, checkFor401) {
        var _this = this;
        if (checkFor401 === void 0) { checkFor401 = true; }
        var queryParams = queryParameters && Object.keys(queryParameters).length
            ? this.serializeQueryParams(queryParameters)
            : null;
        var urlWithParams = url + (queryParams ? '?' + queryParams : '');
        // ugly hack, we need to delete Content-Type header with multipart/form-data
        // that way, browser will calculate form specific headers on it's own
        if (headers.get('Content-Type') === 'multipart/form-data') {
            headers["delete"]('Content-Type');
        }
        if (body && !Object.keys(body).length) {
            body = undefined;
        }
        else {
            body = JSON.stringify(body);
        }
        if (form && Object.keys(form).length) {
            body = new FormData();
            for (var k in form) {
                body.append(k, form[k]);
            }
        }
        return fetch(urlWithParams, {
            method: method,
            headers: headers,
            body: body
        })
            .then(function (response) {
            if (checkFor401) {
                if (response.status === 401) {
                    if (typeof _this._onResponseUnauthorized === 'function') {
                        _this._onResponseUnauthorized();
                    }
                    else {
                        var error = new Error(response.statusText);
                        error.response = response;
                        throw error;
                    }
                }
            }
            if (response.ok) {
                var responseContentType = (response.headers && response.headers.get('Content-Type')) || '';
                if (responseContentType.includes('application/json')) {
                    return response.json();
                }
                else if (responseContentType.includes('application/pdf')) {
                    return response.blob();
                }
                else if (responseContentType.includes('text/plain')) {
                    return response.text();
                }
                return {};
            }
            else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        })["catch"](function (error) {
            return error.response.json().then(function (error_details) {
                error.details = error_details;
                throw error;
            });
        });
    };
    /**
     * Set base url
     * @method
     * @param {string} baseUrl
     */
    Api.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    Object.defineProperty(Api.prototype, "onResponseUnauthorized", {
        set: function (callback) {
            this._onResponseUnauthorized = callback;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Redirects a user to a given url
     * @method
     * @param {string} url
     */
    Api.prototype.redirect = function (url) {
        window.location = url;
    };
    /**
     * Set Auth headers
     * @method
     * @param {object} headerParams - headers object
     */
    Api.prototype.appendAuthHeaders = function (headerParams) {
        var headers = new Headers(headerParams);
        return headers;
    };
    /**
     * Fetch Settings for Given Contentspace
     * @method
     * @param {object} parameters - method options and parameters
     * @param {} appSpace - App space identification
     */
    Api.prototype.publicGetSettings = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/settings';
        var body = {};
        var queryParameters = {};
        var headers = new Headers();
        var form = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace);
        queryParameters = this.mergeQueryParams(parameters, queryParameters);
        return this.request('GET', "".concat(this.baseUrl).concat(path), body, headers, queryParameters, form);
    };
    /**
       * Fetch Settings for Given Contentspace
       * @method
       * @param {object} parameters - method options and parameters
         * @param {} appSpace - App space identification
         * @param {} segment - RESTful API specification.
  
       */
    Api.prototype.publicGetSettingsSegment = function (appSpace, segment, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/settings/{segment}';
        var body = {};
        var queryParameters = {};
        var headers = new Headers();
        var form = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace);
        path = path.replace('{segment}', segment);
        queryParameters = this.mergeQueryParams(parameters, queryParameters);
        return this.request('GET', "".concat(this.baseUrl).concat(path), body, headers, queryParameters, form);
    };
    /**
     * Sends a mail from any contact form using data from app space settings
     * @method
     * @param {object} parameters - method options and parameters
     * @param {} appSpace - App space identification
     * @param {} parameters.body -
     */
    Api.prototype.webContactFormRequest = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/request/web-contact-form';
        var body = {};
        var queryParameters = {};
        var headers = new Headers();
        var form = {};
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace);
        if (typeof parameters['body'] !== 'undefined') {
            body = parameters['body'];
        }
        queryParameters = this.mergeQueryParams(parameters, queryParameters);
        return this.request('POST', "".concat(this.baseUrl).concat(path), body, headers, queryParameters, form);
    };
    return Api;
}());
exports.Api = Api;
exports["default"] = new Api();
